import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@welldev-group/react-comp-lib';
import Button from '@welldev-group/rcl-button';
import ConfirmationModal from 'sharedWebpack/ConfirmationModal';
import Loader from '../../../../admin/Orders/Show/ItemsTab/IssueBooking/components/Loader';
import Error from '../../../../admin/Orders/Show/ItemsTab/IssueBooking/components/Error';
import SuccessModalContent from '../../../SuccessModalContent';
import redirectToOrderItem from '../../../helpers/redirectToOrderItem';
import {
  CONFIRMING,
  CONFIRMED,
  CONFIRMATION_FAILED,
} from '../../reducers/flight/exchangeQuoteStatus';
import './styles.scss';

const ConfirmExchangemodal = ({
  confirmExchangeStatus,
  isVisible,
  exchangeBookingPath,
  itemPath,
}) => {
  const getModalBody = () => {
    if (confirmExchangeStatus === CONFIRMING) {
      return <Loader text={I18n.t('components.flight.exchange.confirm_exchange_modal.loading')} />;
    }

    if (confirmExchangeStatus === CONFIRMATION_FAILED) {
      return (
        <Error
          className="confirm-exchange-modal__error"
          isWithAction={true}
          error={{
            header: I18n.t('components.flight.exchange.confirm_exchange_modal.fail.header'),
            message: I18n.t('components.flight.exchange.confirm_exchange_modal.fail.message'),
          }}
        >
          <div className="d-flex align-center column-gap-8">
            <Button
              size="small"
              primary={true}
              label={I18n.t(
                'components.flight.exchange.confirm_exchange_modal.actions.back_to_order',
              )}
              onClick={() => {
                redirectToOrderItem(itemPath);
              }}
            />
            <Link type="button" href={exchangeBookingPath} size="small" modifier="default">
              {I18n.t('components.flight.exchange.confirm_exchange_modal.actions.start_again')}
            </Link>
          </div>
        </Error>
      );
    }

    if (confirmExchangeStatus === CONFIRMED) {
      return (
        <SuccessModalContent
          content={{
            header: I18n.t('components.flight.exchange.confirm_exchange_modal.success.header'),
            message: I18n.t('components.flight.exchange.confirm_exchange_modal.success.message'),
          }}
          redirectHandler={() => redirectToOrderItem(itemPath)}
        />
      );
    }

    return null;
  };

  return (
    <ConfirmationModal
      className="confirm-exchange-modal"
      isModalOpen={isVisible}
      confirmationHeader={null}
      type=""
      withAction={false}
      subHeader={getModalBody()}
    />
  );
};

ConfirmExchangemodal.propTypes = {
  exchangeBookingPath: PropTypes.string.isRequired,
  itemPath: PropTypes.string.isRequired,
  confirmExchangeStatus: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default ConfirmExchangemodal;
